import "./Foundation/foundation-setup.js";
import "./reauthAjax.js";
import "./ViewComponents/mainHeader.js";
import "./footerAlignment.js";
import "./preventFormSubmission.js";
import "./ParallaxBackgroundEffects.js";
import "../Components/ViewComponents/Navigation/Header/Header.js";
import "./fixAnchorLinkOffset.js";
import "./fixCarouselImageSizing.js";
import "./ViewComponents/addToCalendar.js";
// Social Share buttons
$(document).on("click", ".social-share-button", function () {
  $(".social-share-wrap").removeClass("open");
  $(this).parent().addClass("open");
});
$(document).on("click", function (e) {
  var $container = $(".social-share-wrap");
  if (!$container.is(e.target) && $container.has(e.target).length === 0) {
    $container.removeClass("open");
  }
});

// add to calendar buttons
$(document).on("click", ".button__addToCalendar, .calendar-add-button, .js-add-to-calendar", function () {
    let $button = $(this);
    const config = {
        name: $button.data('name'),
        options: ["Google", "Apple", "Microsoft365"],
        startTime: $button.data("starttime"),
        endTime: $button.data("endtime"),
        timeZone: $button.data("timezone"),
        startDate: $button.data("startdate"),
        endDate: $button.data("enddate"),
        hideIconButton: false,
        hideBackground: true,
        location: "Dallas Market Center, 2100 N Stemmons Fwy, Dallas",
        listStyle: "dropdown",
    };
    atcb_action(config, $button.get(0));
});

/* Close a Foundation accordion or accordion menu on click by adding the
data-accordion-close attr to a link/button within the accordion. Be sure
to use data-allow-all-closed="true" with a regular data-accordion */
$(function () {
    $('[data-accordion] [data-accordion-close]').on('click', function (e) {
        e.preventDefault();
        $(this).closest('[data-accordion-item]').find('.accordion-title').trigger('click');
    });

    $('[data-accordion-menu] [data-accordion-close]').on('click', function (e) {
        e.preventDefault();
        var $clickTarget = $(this).closest('ul').prev('a');
        if ($clickTarget.length) {
            $clickTarget.trigger('click');
        }
    });
});

// handle possible Cumulative Layout Shift after bizform submission
$(document).on("imag-kenticoform:successMsg", function (e) {
    const desktopHeaderHeight = $("nav").height();
    $('html, body').animate({
        scrollTop: $(e.originalEvent.detail.successMsgEl).offset().top - desktopHeaderHeight
    }, 400);
});

function refreshLogin(reload = true) {
    /* this commented approach would be preferable - it doesn't require a new tab or reload -
    but there's a CORS issue that would take a while to sort out
    let success;
    $.ajax({
        url: '/MicrosoftIdentity/Account/SignIn',
        async: false,
        success: () => { success = true; },
        error: () => { success = false; }
    });
    return success;
    */

    if (reload) {
        window.location.href = '/MicrosoftIdentity/Account/SignIn?redirectUrl=' + encodeURIComponent(window.location.href);
    }
    else {
        // opening a page in another tab refreshes the sliding expiration on the login cookie
        var loginTab = window.open('/MicrosoftIdentity/Account/SignIn', '_blank');
        window.focus(); // pull focus back to this tab
        setTimeout(function () {
            loginTab.close();
        }, 500);
    }
}
window.refreshLogin = refreshLogin;
